import { type QueryOptions } from '@tanstack/query-core'

import { type PartnerToSubPartnerEntity } from '@/libs/api'

import {
  fetchPartnerToSubPartners,
  type FetchPartnerToSubPartnersQuery
} from '../api'
import { subPartnersQueryKeys } from '../query-keys'

/**
 * Select用の運送会社一覧のQueryOptionsを返す
 */
export const getSubPartnersSelectQueryOptions = (
  query: FetchPartnerToSubPartnersQuery
): Required<
  Pick<QueryOptions<PartnerToSubPartnerEntity[]>, 'queryKey' | 'queryFn'>
> => {
  return {
    queryKey: subPartnersQueryKeys.select(query),
    queryFn: async ({ signal }) => {
      const { data } = await fetchPartnerToSubPartners(query, signal)
      return data
    }
  }
}
